/**
 * @description  Messages Types
 */

export default Object.freeze({
  BOT: 'bot',
  BOT_SURVEY: 'bot-survey',
  LIVE_CHAT: 'live-chat',
  LIVE_CHAT_SURVEY: 'live-chat-survey',
  SURVEY: 'survey',
  SATISFACTION: 'satisfaction',
  SYSTEM: 'system',
  RELAY_TO_AGENT: 'relay-to-agent',
  FEEDBACK: 'feedback',
  TEXT: 'text',
  CLOSING: 'closing',
  TIMESTAMP: 'timestamp',
  WELCOME: 'welcome',
})
